module.exports = __webpack_public_path__ + "img/prepravko-logo.f2932959.png";